<!--
 * @Description:潜在客户
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-07-13 15:57:47
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectChange }"
        :columns="columns"
        tableId="lbuPotential"
        @fetch="fetch"
        @mask="showMask"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="客户名称" :span="12">
              <a-textarea
                v-model:value="queryForm.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="客户代码" :span="12">
              <a-textarea
                v-model:value="queryForm.tmsCode"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="客户状态">
              <a-select
                v-model:value="queryForm.status"
                allowClear
                placeholder="请选择"
                mode="multiple"
                :options="potentialStatusEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <UserSelect permission v-model:value="queryForm.sellerList" mode="multiple" />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="500"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item label="员工区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.employeeRegionList" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_lbu"
                  paramCode="lbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="时间查询">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeType" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">创建时间</a-select-option>
                  <a-select-option :value="2">首次领取时间</a-select-option>
                  <a-select-option :value="3">最后一次领取时间</a-select-option>
                  <a-select-option :value="4">转为潜在时间</a-select-option>
                </a-select>
                <cos-range-picker
                  style="width: 67%"
                  v-model:startTime="queryForm.startTime"
                  v-model:endTime="queryForm.endTime"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="排序">
              <a-select
                v-model:value="queryForm.sortCollection"
                :options="favoriteStatus"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="剩余跟进天数">
              <a-select
                v-model:value="queryForm.remanentFollowDayType"
                allowClear
                placeholder="请选择"
                :options="remanentFollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户ID">
              <a-input v-model:value="queryForm.cosId" :maxlength="500" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="未跟进天数">
              <a-select
                v-model:value="queryForm.unfollowDayType"
                allowClear
                placeholder="请选择"
                :options="customerUnfollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户识别码">
              <a-input v-model:value="queryForm.customerSerial" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="主账号代码">
              <a-input v-model:value="queryForm.customerNumber" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="路区代码">
              <RoadAreaSelect permission v-model:value="queryForm.roadAreaUserList" allowClear/>
            </dc-form-item>
            <dc-form-item label="客户标签">
              <CustomerLabelCascader type="search" :onlyCommon=false appId="cos_lbu" v-model:ids="queryForm.labelIdList" allowClear/>
            </dc-form-item>
            <dc-form-item label="业务类型">
              <a-select
                v-model:value="queryForm.businessTypeList"
                :options="businessTypeEnum"
                placeholder="请选择"
                mode="multiple"
                allowClear
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd()" v-permission="'lbu_potential_add_btn'">新增</a-button>
          <CosMergeButton
            v-permission="'lbu_potential_merge_btn'"
            :data="selectedRows"
            appId="cos_lbu"
            @success="success"
            >合并</CosMergeButton
          >
          <a-button @click="handleinvalid()" v-permission="'lbu_potential_invalid_btn'" appId="cos_lbu"
            >置为无效</a-button
          >
          <ImportBtn
            action="/lbu/api/customer/import"
            templateUrl="/lbu/api/customer/template/download"
            @success="success('search')"
            v-permission="'lbu_potential_import_btn'"
            >导入</ImportBtn
          >
          <a-button @click="handleTransfer()" v-permission="'lbu_potential_transfer_btn'">转移客户</a-button>
          <ExportButton
            appId="cos_lbu"
            taskType="303"
            :search="handledQueryParams(queryForm)"
            v-permission="'lbu_potential_export_btn'"
            >导出</ExportButton
          >
          <a-button v-permission="'lbu_potential_export_details_btn'" @click="handleExportDetails()">导出明细</a-button>
          <a-button v-permission="'lbu_potential_apply_coupon_btn'" @click="handleApplyCoupon()">发券申请</a-button>
        </template>
        <template #bodyCell="{ column, record, text, index}">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <favorite-icon type="add" v-if="record.collectionId===null"  @click="addFavorite(record,index)"/>
              <favorite-icon type="cancel" v-else  @click="cancelFavorite(record,index)" />
              <p class="time-out-flag" v-if="record.timeoutFlag === true">超时</p>
              <p class="new-list-flag" v-if="record.haveFollowFlag === false">New</p>
              <p class="black-list-flag" v-if="record.customerLabel && record.customerLabel.includes('L')">锁定</p>
              <p class="black-list-flag" v-if="record.customerLabel && record.customerLabel.includes('I')">作废</p>
              <router-link
                :to="`/lbu/potential/view?cosId=${record.cosId}`"
                class="ant-table-cell-ellipsis"
                :title="text"
                >{{ text || '--' }}</router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_lbu" paramCode="lbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'label'">
            <p>{{ record.label ? record.label.map((item) => item.labelName ).join('、') : '--' }}</p>
          </template>
          <template v-if="column.type === 'money'">
            <p>{{ formatThousandSeparator(text)}}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="handleSubContract(record)" v-permission="'lbu_potential_deal_btn'"
                >转成交</a-button
              >
              <a-button type="link" @click="handleFollowUp(record)" v-permission="'lbu_potential_follow_add_btn'"
                >写跟进</a-button
              >
              <a-button type="link" @click="handleEdit(record)" v-permission="'lbu_potential_edit_btn'">编辑</a-button>
              <a-button type="link" @click="handleRelationCustomer(record)" v-permission="'lbu_potential_relative_btn'"
                >关联客户</a-button
              >
              <a-button type="link" v-permission="'lbu_potential_send_link_btn'" @click="handleSendLink(record)"
                >发送注册链接</a-button
              >
              <a-button type="link" v-permission="'lbu_potential_map_btn'" @click="handleMap(record)"
                >签到地址</a-button
              >
            </more-button>
          </template>
        </template>
      </cos-table>
      <!--转移客户--->
      <transferModel ref="transferModelRef" @success="success" />
      <!--关联客户--->
      <relationCustomer ref="relationCustomerRef" @success="success" />
      <!--发送注册链接--->
      <sendLinkModel ref="sendLinkModelRef" />
      <!-- 客户地址修改弹窗 -->
      <CustomerMaps ref="customerMapsRef" />
      <!--置为无效弹窗--->
      <invalidModel ref="invalidModelRef" @success="success" />

      <ApplyCoupon ref="applyCouponRef" @success="success" />

      <!-- 导出明细 -->
  <ExportDetails ref="exportDetailsRef" appId="cos_lbu" :search="queryForm" :taskTypeEnum="[
  { value: 312, label: '签到地址' },
  { value: 315, label: '在售平台' },
  { value: 318, label: '目的地国家' },
  { value: 321, label: '物流商' },
  { value: 324, label: '货物品类' },
  { value: 327, label: 'ERP系统' }
]"/>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import { potentialList, potentialDetail } from '@/api/yuntuSales/customerCenter'
import {
  businessTypeEnum,
  potentialStatusEnum,
  customerTypeEnum,
  remanentFollowDayTypeEnum,
  customerUnfollowDayTypeEnum,
  tmsCustomerValueEnum, favoriteStatus
} from '@/views/yuntuSales/commonEnum/dataConfig'
import ImportBtn from '@/components/ImportBtn'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import RelationCustomer from '@/components/RelationCustomer/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import CustomerMaps from '@/components/CustomerMaps/index.vue'
import CosMergeButton from '@/components/CosMergeButton'
import SendLinkModel from '../components/sendLinkModel.vue'
import transferModel from '../components/transferModel.vue'
import invalidModel from '../components/invalidModel.vue'
import ApplyCoupon from '../components/applyCoupon.vue'
import { useRouter, useRoute } from 'vue-router'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes, addToFav, cancelToFav } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const transferModelRef = ref()
const invalidModelRef = ref()
const sendLinkModelRef = ref()
const relationCustomerRef = ref()
const customerMapsRef = ref()

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const applyCouponRef = ref()
const handleApplyCoupon = () => {
  applyCouponRef.value.toggle(selectedRows.value)
}

const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  sortCollection: 1,
  timeType: 1,
  contact: {
    type: 1
  },
  stage: 2 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  lbu_customer_business_area: []
  lbu_sales_category: []
  lbu_cargo_type: []
  lbu_logistics_service_provider: []
  lbu_shipping_channel: []
  lbu_daily_traffic: []
  lbu_sale_platform: []
  lbu_demand_country: []
  lbu_erp_info: []
  lbu_invalid_reason: []
  lbu_important: []
}>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_invalid_reason: [],
  lbu_important: []
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_invalid_reason',
      'lbu_important'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handledQueryParams = (params: any) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(params)
  potentialList({
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
// 掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}

const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 置为无效
const handleinvalid = () => {
  invalidModelRef.value.toggle(selectedRows.value)
}
// 关联客户
const handleRelationCustomer = (row: PotentialItem) => {
  relationCustomerRef.value.toggle(row)
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
const handleMap = (row: PotentialItem) => {
  customerMapsRef.value.toggle({
    addressRefId: row.cosId,
    addressRefName: row.customerName
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/lbu/potential/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 新增
const handleAdd = () => {
  router.push({
    path: '/lbu/potential/add'
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 转成交
const handleSubContract = (row: PotentialItem) => {
  router.push({
    path: '/lbu/turnToDeal',
    query: {
      cosId: row.cosId
    }
  })
}
// 收藏
const addFavorite = (row: PotentialItem, index:number) => {
  addToFav({
    appId: 'cos_lbu',
    cosId: row.cosId,
    stage: 2
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.cosId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: PotentialItem, index:number) => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: row.cosId,
    stage: 2
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const statusEnum = potentialStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))

// 36
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: 'ID', dataIndex: 'cosId', width: 200 },
  { title: '状态', dataIndex: 'status' },
  { title: '来源渠道', dataIndex: 'channel', width: 150 },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '客户类型', dataIndex: 'type', dicData: customerTypeEnum },
  { title: '剩余跟进天数', dataIndex: 'remanentFollowDays' },
  { title: '未跟进天数', dataIndex: 'unfollowDays' },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '传真号', dataIndex: ['contact', 'fax'] },
  { title: '备注', dataIndex: 'remark' },
  // { title: '业务地区', dataIndex: ['business', 'businessArea'], dicData: paramCodeData.lbu_customer_business_area },
  { title: '业务收入等级', dataIndex: ['business', 'monthIncome'], dicData: paramCodeData.lbu_important },
  { title: '年销售GMV（元）', dataIndex: ['business', 'annualSales'], type: 'money', width: 150, sorter: true },
  // { title: '销售品类', dataIndex: ['business', 'salesCategory'], dicData: paramCodeData.lbu_sales_category },
  // { title: '货物类型', dataIndex: ['business', 'cargoType'], dicData: paramCodeData.lbu_cargo_type },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider,
  //   width: 150
  // },
  // { title: '出货渠道', dataIndex: ['business', 'deliveryChannel'], dicData: paramCodeData.lbu_shipping_channel },
  // {
  //   title: '客户日均包裹数量',
  //   dataIndex: ['business', 'dailyTraffic'],
  //   dicData: paramCodeData.lbu_daily_traffic,
  //   width: 150
  // },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '转为潜在时间', dataIndex: 'turnedPotential', width: 190, sorter: true },
  { title: '无效原因', dataIndex: 'invalidReason', dicData: paramCodeData.lbu_invalid_reason },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  {
    title: '操作',
    dataIndex: 'action',
    width: 240,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuPotential' }
</script>

<style scoped></style>
